import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpErrorHandlerService } from './http-error-handler.service';
import { environment } from '@environments';
import { UserProfile } from '@models/webapi/user-profile';
import { catchError, map, Observable } from 'rxjs';
import { USER_PROFILE_ENDPOINT } from '@models/common.models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly #http = inject(HttpClient);
  readonly #httpErrorHandler = inject(HttpErrorHandlerService);
  readonly #webApiUrl = environment.apiConfig.baseUrl;

  public getProfile(): Observable<UserProfile | null> {
    return this.#http
      .get<UserProfile>(`${this.#webApiUrl}${USER_PROFILE_ENDPOINT}`)
      .pipe(
        map(response => UserProfile.from(response)),
        catchError((error: unknown) => {
          this.#httpErrorHandler.handleError(error);
          throw error;
        })
      );
  }
}
